import React, { useState, useEffect, createRef } from "react";
import Layout from "../../Layout";
import { H2 } from "../../Common/Typography";
import { BodyContent, Container } from "../../Common/GridSystem";
import styled from "styled-components";
import COLORS from "../../../assets/colors";
import BackNav from "../../Common/BackNav";
import { PrimaryButton } from "../../Common/Buttons/PrimaryButton";
import { AddCancelButton } from "../../Common/Buttons/ButtonIcon";
import { Formik, Form } from "formik";
import FormTextField from "../../Common/FormElements/FormTextField";
import { skillManageMentValidation } from "../../../validations/personaValidation";
import { SkillService } from "../../../services/SkillService";
import DropDown from "../../Common/FormElements/DropDown";
import AIGenerator from "../../Common/AIGenerator";
import { SecondaryButton } from "../../Common/Buttons/SecondaryButton";
import useAlert from "../../../Hooks/useAlert";
import useFullLoader from "../../../Hooks/useFullLoader";
import { navigate } from "@reach/router";
import ConfirmationButton from "../../Common/ConfirmationButton";
import ModalPopup from "../../Common/ModalPopup";
import AutoSelect from "../../Common/FormElements/AutoSelect";
import CreateSkillTree from "./CreateSkillTree";
import useAuth from "../../../Hooks/useAuth";
import { SortString } from "../../../helpers/SortString";
import ChipList from "../../Common/Others/ChipList";
import AutoSelectSearch from "../../Common/FormElements/AutoSelectSearch";
import DropDownState from "../../Common/FormElements/DropDownState";
import Label from "../../Common/FormElements/Label";
import { navigateToTagURL,  showAiGeneratorModal, getGeneratorType, getAiGeneratorTitle, getServiceUrl, getConfirmText, isGenAiDisprzAtomicSkillSource, } from "../../../helpers/CommonHelper";
import { skillGeneratorMapping } from "../../../helpers/GeneratorMappingHelper";
import { AIStore, SkillStore } from "../../../store/store_state";
import { SourceType } from "../../../enums/SourceType";
import { renderAIButton } from "../../Common/Buttons/RenderAiButton";
import SkillsManageTable from "./SkillManageTable/SkillsManageTable";
import text from "../../../locale.en.json"

export default (props) => {
  const { mode, id } = props;
  const { showAlert } = useAlert();
  const { skillstatusMenuList, userDetails } = useAuth();
  const { User_Type } = userDetails;
  const { setFullLoader } = useFullLoader();

  let formRef = createRef();

  const [encyclopediaSize, setEncyclopediaSize] = useState(0);
  const [encyclopediaState, setEncyclopediaState] = useState("");
  const [encyclopediaTypeState, setEncyclopediaTypeState] = useState(1);
  const [encycloCurrentList, setEncycloCurrentList] = useState([]);
  const aiSuggestedEncycloLists = AIStore.useState((s) => s.aiSuggestedEncycloLists);
  const skillDetail = AIStore.useState((s) => s.skillDetail);

  const [detailData, setDetailData] = useState(null);
  const [categoryMenu, setCategoryMenu] = useState([]);
  const [familyMenu, setFamilyMenu] = useState([]);
  const [sourceMenu, setSourceMenu] = useState([]);
  const [encyclopediaTypes, setEncyclopediaTypes] = useState([]);

  const [confirmPopup, setConfirmPopup] = useState(false);
  const [confirmType, setConfirmType] = useState(null);
  const [confirmTitle, setConfirmTitle] = useState("");
  const [fieldValues, setFieldValues] = useState(null);
  const [skillTreeModal, setSkillTreeModal] = useState(false);
  const [treeData, setTreeData] = useState(null);
  const [selectedSource, setSelectedSource] = useState(0);  
  const [levels, setLevels] = useState([]);
  const [selectedPL, setSelectedPL] = useState(0);
  const [schemeIDData, setSchemeIDData] = useState([]);
  
  const getProficiencySchemes = async () => {
    try {
      const resCat = await SkillService.getProficiencySchemes();
      const data = resCat?.value || [];
  
      // Extract levelCounts and remove duplicates
      const levelCounts = [...new Set(data.map(item => item.levelCount))];
  
      // Sort ascending
      const sortedLevels = levelCounts.sort((a, b) => a - b);
  
      setLevels(sortedLevels);
    
      if(data?.length>0){
         setSchemeIDData(data);
      }
      // Set lowest as selected
      if (sortedLevels.length > 0) {
        setSelectedPL(sortedLevels[0]);
      }
    } catch (error) {
      console.error("Failed to fetch proficiency schemes", error);
    }
  };
  
  
  // Call it in useEffect or some lifecycle point
  useEffect(() => {
    getProficiencySchemes();
    resetAiSkillStore();  
  }, []);

  const checkSkillNameExist = async (name) => {
    var response = await SkillService.checkSkillExistsV3(name, Number(id))
    if (response.value)
      return "This skill already exists";
    return "";
  }

  const initialStateForAiGeneratorPopUp = {
    showKnowledgeBasePopUp: false,
    showSkillShortDescriptionPopUp: false,
    showSkillDetailedDescriptionsPopUp: false
  }
  const [showAiGeneratorPopUp, setShowAiGeneratorPopUp] = useState(initialStateForAiGeneratorPopUp);
  const skillSourceId = SkillStore.useState((s) => s.sourceId);

  const [showBox, setShowBox] = useState(false);
  const chipAdd = () => setShowBox((prev) => !prev);

  const getListData = async () => {
    setFullLoader(true);
    try {
      const resCat = await SkillService.getSkillCategoriesV3();
      const categorySorted = SortString(resCat, "skillCategory").map((el) => ({
        label: el.skillCategory,
        value: el.skillCategoryId,
      }));
      setCategoryMenu(categorySorted);

      if (mode === "add") {
        changeFamilyMenu(categorySorted[0]?.value);
      }

      const resSrc = await SkillService.getSkillSourcesV3();
      setSourceMenu(
        SortString(resSrc, "source").map((el) => ({
          label: el.source,
          value: el.sourceId,
        }))
      );

      const resGetEncyclopediaTypes = await SkillService.GetEncyclopediaTypesV3();
      setEncyclopediaTypes(
        SortString(resGetEncyclopediaTypes, "encyclopediaType").map((el) => ({
          label: el.encyclopediaType,
          value: el.encyclopediaTypeId,
        }))
      );
    } catch (err) {
      console.log(err);
    } finally {
      setFullLoader(false);
    }
  };

  const resetAiSkillStore = () => {
    AIStore.update((s) => {
     s.aiSuggestedEncycloLists = [];
     s.aiSuggestedSkillShortDescriptions =  [];
     s.aiSuggestedSkillDetailedDescriptions =  [];
     s.aiSuggestedProficienyDescription = [];
     s.aiSuggestedKnowledgeDescription = [];
     s.aiSuggestedKnowledgeDescriptionV2={};
     s.aiSuggestedProficienyDescriptionV2 ={};
      s.aiSuggestedlevelDescriptionCopy = {
        aiSuggestedProficienyDescription: [],
        aiSuggestedKnowledgeDescription: []
      };
    })
   }

  const getDetailData = async (arrangeFamilyMenu = false) => {
    try {
      const res = await SkillService.getSkillDetailV3("/" + Number(id), "?includeProficiencies=true");

      setDetailData(res);
      SkillStore.update((s) => {s.sourceId = mode === "add" ? SourceType.DISPRZ_ATOMIC_SKILLS  : res?.skillSource?.sourceId});
      let newskillDetail = {skillName: res.skillName, skillFamily: res.skillFamily.skillFamily}
      if(JSON.stringify(skillDetail) !== JSON.stringify(newskillDetail)){
        AIStore.update((s) => {
           s.skillDetail = newskillDetail;
        })
        resetAiSkillStore();
     };
      setEncycloCurrentList(res.encyclopedia);
      if(JSON.stringify(skillDetail) === JSON.stringify(newskillDetail)){
        let newEncyclopedia = [...res.encyclopedia];
        console.log(147, newEncyclopedia, aiSuggestedEncycloLists, newskillDetail, skillDetail)
        let currAiSuggestedEncyclopedia = [...aiSuggestedEncycloLists];
        currAiSuggestedEncyclopedia = currAiSuggestedEncyclopedia?.map((item) => {
          if(newEncyclopedia.every((el) => el.encyclopediaId !== item.encyclopediaId)){
            const { isSelected, isDisabled, ...newItem } = item;
            return { ...item, isSelected: false, isDisabled: false };
          }
          return item
        })
        AIStore.update((s) => {s.aiSuggestedEncycloLists = [...currAiSuggestedEncyclopedia]});
      }
      if (arrangeFamilyMenu) {
        changeFamilyMenu(res?.skillCategory?.skillCategoryId);
      }
    } catch (error) {
      showAlert(error.error, "error", 1500);
    }
  };

  useEffect(() => {
    if (!!skillstatusMenuList?.length && !!detailData) {
      const checkStatus = skillstatusMenuList.some(
        (status) => status.value === detailData.skillStatus
      );
      if (!checkStatus) {
        showInfoAndNavigate();
      }
    }
  }, [skillstatusMenuList, detailData]);

  const showInfoAndNavigate = async () => {
    await showAlert("User doesn't have access to this page", "Info", 1500);
    navigate("/");
  };

  useEffect(() => {
    getListData();
    if (mode === "edit") {
      getDetailData(true);
    }
    return () => {
    };
  }, [mode]);

  const formSubmit = (values) => {
    try {
      const setupValues = {
        ...values,
        encyclopediaId: values?.encyclopediaId?.map(
          ({ encyclopediaId }) => encyclopediaId
        ),
        skillFamilyId:
          typeof values.skillFamilyId === "string"
            ? familyMenu?.find((el) => el.label === values.skillFamilyId)
                ?.value || values.skillFamilyId
            : values.skillFamilyId.value,
      };

      setFieldValues(setupValues);
      setConfirmType(mode);
      if (mode === "edit") {
        setConfirmTitle("Confirm Changes");
      } else {
        setConfirmTitle("Confirm Skill Addition");
      }
      setConfirmPopup(true);
    } catch (err) {
      console.log(err);
    }
  };

  const addOrUpdate = async (values) => {
    setFullLoader(true);
    try {
      const submitValues = values || fieldValues;
      if (typeof submitValues.skillFamilyId === "number") {
        if (mode === "edit") {
          await SkillService.updateSkillDetailV3("/" + Number(id), submitValues);
          await showAlert("Skill Updation Successful", "success", 1500);
          closePopup();
          getDetailData(false);
        } else {
          const skillDetail = await SkillService.addSkillDetailV3(submitValues);
          await showAlert("Skill Creation Successful", "success", 1500);
          closePopup();
          setTimeout(() => navigate(`edit/${skillDetail.skillId}`), 100);
        }
      } else {
        const familyPostData = {
          skillCategoryId: fieldValues.skillCategoryId,
          skillFamily: fieldValues.skillFamilyId,
        };
        const res = await SkillService.createFamilyV3(familyPostData);
        const resObj = { ...fieldValues, skillFamilyId: res };
        addOrUpdate(resObj);
      }
    } catch (err) {
      showAlert(err.error, "error", 1500);
    } finally {
      setFullLoader(false);
    }
  };

  const editMode = mode === "edit" && !!detailData;

  const handleDeleteSkill = async () => {
    setFullLoader(true);
    try {
      await SkillService.deleteSkillDetailV3("?skillId=" + Number(id));
      await showAlert("Skill Deletion Successful", "success", 2500);
      closePopup();
      setTimeout(() => navigate(`/skill/search`), 100);
    } catch (err) {
      showAlert(err.error, "error", 2500);
    } finally {
      setFullLoader(false);
    }
  };

  const handleDelete = () => {
    setConfirmType("delete");
    setConfirmTitle("Delete Skill - " + detailData.skillName + " ?");
    setConfirmPopup(true);
  };

  const handleYes = () => {
    if (confirmType === "delete") {
      handleDeleteSkill();
    } else if (confirmType === "redirect") {
      navigate("/skill/search");
    } else {
      addOrUpdate();
    }
  };
  const handleNo = () => closePopup();

  const closePopup = () => {
    setConfirmPopup(false);
    setConfirmType(null);
    setConfirmTitle("");
  };


  const closeSkillTree = () => {
    setSkillTreeModal(false);
    setTreeData(null);
  };


  const handleChangeWiki = (item, reason, setFieldValue) => {
    console.log("handleChangeWiki -> reason", reason);
    if (reason === "select-option") {
      if (
        !encycloCurrentList.some(
          (el) => el.encyclopediaId === item.encyclopediaId
        )
      ) {
        setEncycloCurrentList((prev) =>
          reason === "select-option" ? [...prev, item] : prev
        );
        // setEncyclopediaState(item);
        setFieldValue("encyclopediaId", [...encycloCurrentList, item]);
      } else {
        showAlert("Encyclopedia already added", "info", 1500);
      }
    }
  };

  useEffect(() => {
    if(showAiGeneratorPopUp.showKnowledgeBasePopUp){
      const updatedAiSuggestedEncycloLists = aiSuggestedEncycloLists.map((el) => {
        const foundItem = encycloCurrentList.some((item) => item?.encyclopediaId === el?.encyclopediaId);
        if (foundItem) {
          return {
            ...el,
            isSelected: false,
            isDisabled: true,
          };
        } else if (!el?.isInValidId) {
          return {
            ...el,
            isDisabled: false,
          };
        }
        return el;
      });
      AIStore.update((s) => {
        s.aiSuggestedEncycloLists = updatedAiSuggestedEncycloLists;
      });
    }
  },[showAiGeneratorPopUp.showKnowledgeBasePopUp])

  const removeChip = (item, values, name, setFieldValue) => {
    setFieldValue(
      name,
      values.filter((el) => el.url !== item.url)
    );
    setEncycloCurrentList((prev) =>
      prev.filter((el) => el.url !== item.url)
    );
  };

  const triggerApi = (searchString, _, pageSize) => {
    setEncyclopediaState(searchString);
    return triggerBounce(searchString, pageSize);
  };

  const triggerBounce = async (searchString, pageSize) => {
    try {
      const pageParam = `?offset=${0}&pagesize=${pageSize}`;
      const res = await SkillService.GetEncyclopediaV3(
        encyclopediaTypeState,
        searchString,
        pageParam
      );
      setEncyclopediaSize(res?.total);
      return res.data;
    } catch (errors) {
      console.log(errors);
    }
  };

  const handleEncyclopediaTypes = (e) =>
    setEncyclopediaTypeState(e.target.value);

  const handleSourceChange = async (e, setFieldValue) => {
    const { name, value } = e.target;
    setFieldValue(name, value);
    setSelectedSource(value)
  };
  
  const handleCategoryChange = async (e, setFieldValue) => {
    const { name, value } = e.target;
    setFieldValue(name, value);
    setFieldValue("skillFamilyId", "");
    if (!!editMode) {
      showAlert(
        "Message on Update page - <br />Changing Skill Category might result in a cross-category skill tree, <br />please review the skill tree before updating the skill!",
        "info",
        5000
      );
    }
    changeFamilyMenu(value);
  };

  const changeFamilyMenu = async (categoryId) => {
    const resFam = await SkillService.getSkillFamiliesV3(
      `?categoryIds=${categoryId}`
    );

    setFamilyMenu(
      SortString(resFam, "skillFamily").map((el) => ({
        label: el.skillFamily,
        value: el.skillFamilyId,
      }))
    );
  };

  // Function to handle cancel click of AiGeneratorComponent and reset the popup state
  const handleAiGeneratorCancelClick = () => {
    const resetAiGeneratorPopUp = { ...initialStateForAiGeneratorPopUp };
    setShowAiGeneratorPopUp(resetAiGeneratorPopUp);
  }

  //Function to handle confirm click of AiGeneratorComponent and update the states
  const handleAiGeneratorConfirmClick = (value = "", values = "", setFieldValue) => {
    if(showAiGeneratorPopUp.showKnowledgeBasePopUp){
      let updatedEncycloLists = [];
      let updatedAiSuggestedEncycloListst = [...aiSuggestedEncycloLists];
      updatedAiSuggestedEncycloListst =  updatedAiSuggestedEncycloListst.map((el) => {
        if (!!el.isSelected) {
          const { isSelected, isDisabled, ...newEl } = el;
          updatedEncycloLists.push(newEl);
          return { ...el, isSelected: false, isDisabled: true };
        }
        return el;
      })
      AIStore.update((s) => {s.aiSuggestedEncycloLists = [...updatedAiSuggestedEncycloListst]});
      setFieldValue(
        'encyclopediaId',
        [...encycloCurrentList, ...updatedEncycloLists]
      );
      setEncycloCurrentList((prev) => ([...prev, ...updatedEncycloLists]));
    }
    else if(showAiGeneratorPopUp.showSkillShortDescriptionPopUp){
      setFieldValue('skillDescription', values.skillDescription ? `${values.skillDescription} ${value}` : value);
    }
    else if(showAiGeneratorPopUp.showSkillDetailedDescriptionsPopUp){
      setFieldValue('embeddingDescription', values.embeddingDescription ? `${values.embeddingDescription} ${value}` : value);
    }
    handleAiGeneratorCancelClick();
  }

  const getStoreKey = () => {
    if(showAiGeneratorPopUp.showKnowledgeBasePopUp){
      return 'aiSuggestedEncycloLists';
    }else if(showAiGeneratorPopUp.showSkillShortDescriptionPopUp){
      return 'aiSuggestedSkillShortDescriptions';
    }else if(showAiGeneratorPopUp.showSkillDetailedDescriptionsPopUp){
      return 'aiSuggestedSkillDetailedDescriptions'
    }
  }


  const checkAndShowAiGeneratorPopUp = (values, popUpToShow) => {
    let skillName = values?.skillName;
    let skillFamily = (values?.skillFamilyId && typeof values?.skillFamilyId === 'object')
      ? values?.skillFamilyId?.label
      : values?.skillFamilyId;
    const emptyFields = [];
    if (!skillName) {
      emptyFields.push('Skill Name');
    }
    if (!skillFamily) {
      emptyFields.push('Skill Family');
    }
    if (emptyFields.length > 0) {
      const emptyFieldsList = emptyFields.join(', ');
      showAlert(`Please fill in the following fields: ${emptyFieldsList}`, "info", 1500);
      return;
    }else {
      let currSkillDetail = {skillName: skillName, skillFamily: skillFamily};
      if(JSON.stringify(currSkillDetail) !== JSON.stringify(skillDetail)){

        AIStore.update((s) => {s.skillDetail = currSkillDetail});
        resetAiSkillStore();
      }
      setShowAiGeneratorPopUp({[popUpToShow]: true});
    }
  }


  const initData = {
    skillName: editMode ? detailData.skillName : "",
    skillDescription: editMode ? detailData.skillDescription : "",
    embeddingDescription: editMode ? detailData.embeddingDescription : "",
    skillCategoryId: editMode ? detailData.skillCategory.skillCategoryId : "",
    skillFamilyId: editMode ? detailData.skillFamily.skillFamily : "",
    sourceId: editMode ? detailData?.skillSource?.sourceId : "",
    skillStatus: editMode ? detailData.skillStatus : "",
    encyclopediaId: editMode ? detailData?.encyclopedia || [] : [],
  };

  const getSourceMenuList = (editMode) => {
    const menu = [...sourceMenu]; // or however it's built
    return !editMode
      ? menu.filter(
          (el) => el.value === SourceType.DISPRZ_ATOMIC_SKILLS || el.value === SourceType.DISPRZ_ATOMIC_1_1
        )
      : menu;
  };
  
  return (
    <Layout>
      <H2>Skill Management</H2>
      <BodyContent>
        <Container>
        <HeaderContainer>
          <BackNav linkNav="/skill/search" />
          {mode === "edit" &&  isGenAiDisprzAtomicSkillSource(initData.sourceId) && (
              <SecondaryButton
                onClick={handleDelete}
                style={{ marginLeft: 15 }}
              >
                Delete Skill
              </SecondaryButton>
            )}
          </HeaderContainer>
          <WhiteBg>
            <Formik
              enableReinitialize={true}
              initialValues={initData}
              validationSchema={skillManageMentValidation}
              onSubmit={formSubmit}
              innerRef={formRef}
            >
            {({ setFieldValue, setValue, setFieldTouched, fieldValues, values, touched, errors,  dirty, isValid }) => {
                return (
                  <FormBlock>
                    <SearchBlock>
                      <FormTextField
                        label="Skill Name"
                        name="skillName"
                        setVal={setFieldValue}
                        setTouched={setFieldTouched}
                        className="skillName"
                        customValidate={checkSkillNameExist}
                      />
                      <DropDown
                        list={categoryMenu}
                        name="skillCategoryId"
                        width="190px"
                        label="Category"
                        handleChange={(e) =>
                          handleCategoryChange(e, setFieldValue)
                        }
                      />
                      {!!familyMenu && (
                        <div className="auto-search">
                          <AutoSelect
                            label="Family"
                            name="skillFamilyId"
                            list={familyMenu}
                            renderOption={(option) => (
                              <OptionCutom>{option.label}</OptionCutom>
                            )}
                            optionLabel={"label"}
                            freeSolo={true}
                          />
                        </div>
                      )}
                      <div className={editMode ? "source-dropDown" : ""}>
                        <DropDown
                          list={getSourceMenuList(editMode)}
                          name="sourceId"
                          width="190px"
                          label="Source"
                          handleChange={(e) =>
                            handleSourceChange(e, setFieldValue)
                          }
                          disabled={!!editMode}
                        />
                      </div>
                      <DropDown
                        list={skillstatusMenuList || []}
                        name="skillStatus"
                        width="190px"
                        label="Status"
                      />
                    </SearchBlock>
                    {!(
                        isGenAiDisprzAtomicSkillSource(selectedSource) ||
                        isGenAiDisprzAtomicSkillSource(initData.sourceId)
                      ) && (  
                      <>  
                        <ContainerX>
                          <Label style={{ color: COLORS.TITLE_BLUE }}>
                            Knowledge Base
                          </Label>
                     {renderAIButton({mode, sourceId: skillSourceId, clickHandler:() => checkAndShowAiGeneratorPopUp(values, 'showKnowledgeBasePopUp')})}
                        </ContainerX>
                        <ChipBlock showBox={!!values.encyclopediaId?.length}>
                          {!!values?.encyclopediaId && (
                            <ChipList
                              list={values.encyclopediaId}
                              optionLabel="encyclopedia"
                              onDelete={(item) =>
                                removeChip(
                                  item,
                                  values.encyclopediaId,
                                  "encyclopediaId",
                                  setFieldValue
                                )
                              }
                          chipClick={(val) => navigateToTagURL(val, showAlert)}
                              style={{ paddingBottom: 0 }}
                            />
                          )}
                          <AddCancelButton
                            onClick={chipAdd}
                            showBox={showBox}
                            title={showBox ? "Cancel" : "Add"}
                          >
                            <div class="leftright"></div>
                            <div class="rightleft"></div>
                          </AddCancelButton>
                        </ChipBlock>
                      </>
                    )}
                    <div style={{ display: showBox ? "block" : "none" }}>
                      <SearchBlock>
                        <DropDownState
                          list={encyclopediaTypes || []}
                          name="leadership_role_id"
                          width="190px"
                          handleChange={handleEncyclopediaTypes}
                          value={encyclopediaTypeState}
                        />
                        <DropDownRow>
                          <AutoSelectSearch
                            width={320}
                            freeSolo={false}
                            optionChange={(item, reason) =>
                              !!item
                                ? handleChangeWiki(item, reason, setFieldValue)
                                : undefined
                            }
                            handleClearSearch={() => setEncyclopediaState("")}
                            optionLabel="encyclopedia"
                            placeholder="Search encyclopedia"
                            stateValue={encyclopediaState}
                            enterResetSearch={(val) => {
                              setEncyclopediaState(val);
                            }}
                            triggerApi={(val, reason, pageSize) =>
                              triggerApi(val, reason, pageSize)
                            }
                            renderOption={(option) => (
                              <div style={{ width: "100%" }}>
                                {option?.encyclopedia}
                              </div>
                            )}
                            listSize={encyclopediaSize}
                          />
                        </DropDownRow>
                      </SearchBlock>
                    </div>
                    <SkillDescriptionX>
                      {renderAIButton({mode,sourceId: skillSourceId, clickHandler:() => checkAndShowAiGeneratorPopUp(values, 'showSkillShortDescriptionPopUp'), style: { position: 'absolute', top: '-5px', left: '137px' }})}
                      <FormTextField
                        multiline={true}
                        disabled={false}
                        rows="5"
                        rowsMax="1000"
                        name="skillDescription"
                        label="Skill Description"
                        setVal={setFieldValue}
                        setTouched={setFieldTouched}
                      />
                    </SkillDescriptionX>
                    <SkillDescriptionX>
                      {renderAIButton({mode, sourceId: skillSourceId, clickHandler: () => checkAndShowAiGeneratorPopUp(values, 'showSkillDetailedDescriptionsPopUp'), style: { position: 'absolute', top: '-5px', left: '165px' }})}
                      <div className="description-container">
                        <FormTextField
                          multiline={true}
                          disabled={false}
                          rows="5"
                          rowsMax="1000"
                          name="embeddingDescription"
                          label={text.skill.detailedDescription}
                          setVal={setFieldValue}
                          setTouched={setFieldTouched}
                        />
                        <div className="description-text">
                          <i>{text.skill.detailedDescriptionInfo}</i>
                        </div>
                      </div>
                    </SkillDescriptionX>
                    {isGenAiDisprzAtomicSkillSource(initData.sourceId) && (
                        mode === "edit" ? (
                          <PrimaryButton type="submit" disabled={!(dirty && isValid)}>
                            Save
                          </PrimaryButton>
                        ) : (
                          <PrimaryButton type="submit">
                            Add Skill
                          </PrimaryButton>
                        )
                      )}
                    <>
                      {editMode && (
                        <>
                          {isGenAiDisprzAtomicSkillSource(initData.sourceId) && (
                            <>
                            <Line />
                              <PLSelectionBlock>
                                <Title>{text.skill.plLevelConfig}</Title>
                                <ButtonGroup>
                                  {levels.map((level) => (
                                    <PLButton
                                      key={level}
                                      active={selectedPL === level}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedPL(level);
                                      }}
                                      type="button"
                                    >
                                      {level} PL
                                    </PLButton>
                                  ))}
                                </ButtonGroup>
                              </PLSelectionBlock>
                            </>
                          )}
                          {selectedPL && schemeIDData?.length &&
                            <SkillsManageTable
                              {...props}
                              detailData={detailData}
                              skillDetail={skillDetail}
                              levels={isGenAiDisprzAtomicSkillSource(skillSourceId) ? selectedPL : 5}
                              schemeIDData= {schemeIDData}
                            />
                          }
                        </>
                      )}
                    </>
                    {!isGenAiDisprzAtomicSkillSource(initData.sourceId)
                      && (
                      <PrimaryButton type="submit">
                        {mode === "edit" ? "Update Skill" : "Add Skill"}
                      </PrimaryButton>
                    )}
                    {mode === "edit" &&
                      !isGenAiDisprzAtomicSkillSource(initData.sourceId)
                        && (
                          <SecondaryButton
                            onClick={handleDelete}
                            style={{ marginLeft: 15 }}
                          >
                            Delete Skill
                          </SecondaryButton>
                      )}
                    <ModalPopup
                      open={showAiGeneratorModal(showAiGeneratorPopUp)}
                      maxWidth={!!showAiGeneratorPopUp?.showKnowledgeBasePopUp ? "sm" : "lg"}
                      title={getAiGeneratorTitle(showAiGeneratorPopUp, skillGeneratorMapping)}
                      center={true}
                    >
                      <AIGenerator
                        generatorType={getGeneratorType(showAiGeneratorPopUp, skillGeneratorMapping)}
                        getServiceUrl={getServiceUrl(showAiGeneratorPopUp, skillGeneratorMapping)}
                        params={skillDetail}
                        cancelText="Close"
                        confirmText={getConfirmText(showAiGeneratorPopUp, skillGeneratorMapping)}
                        onCancel={() => handleAiGeneratorCancelClick()}
                        onConfirm={(value) => handleAiGeneratorConfirmClick(value, values, setFieldValue)}
                        placeholder=""
                        encycloCurrentList={showAiGeneratorPopUp.showKnowledgeBasePopUp ? encycloCurrentList : []}
                        detailedDescription={showAiGeneratorPopUp.showSkillDetailedDescriptionsPopUp}
                        aiStoreKey={getStoreKey()}
                      />
                    </ModalPopup>

                  </FormBlock>
                );
              }}
            </Formik>
          </WhiteBg>
        </Container>
        {skillTreeModal && (
          <ModalPopup
            open={skillTreeModal}
            maxWidth="lg"
            title="Skill Tree"
            center={true}
            closePopup={closeSkillTree}
          >
            <CreateSkillTree
              data={detailData}
              getTreeData={(data) => setTreeData(data)}
            />
          </ModalPopup>
        )}
        <ModalPopup
          open={confirmPopup}
          maxWidth="sm"
          title={confirmTitle}
          center={true}
        >
          <ConfirmationButton yesClick={handleYes} noClick={handleNo} />
        </ModalPopup>
      </BodyContent>
    </Layout>
  );
};

const WhiteBg = styled.div`
  background-color: ${COLORS.PRIMARY_WHITE};
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(97, 122, 163, 0.24);
  padding: 30px;
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0px;
  }
  table {
    padding: 0px 10px;
  }
`;

const FormBlock = styled(Form)`
  margin-top: 15px;
  width: 80%;
  @media (max-width: 1100px) {
    width: 100%;
  }
  .description-container {
    position: relative
    .toggle-detailed-description {
      position: absolute;
      bottom: 30px;
      right: 10px;
    }
    >:nth-child(1){
      padding-bottom: 8px;
    }
    .description-text{
      display: flex;
      justify-content: flex-end;
      font-size: 12px;
      line-height: 120%;
      color: ${COLORS.PRIMARY_BLACK};
      margin-top: 0px;
    }
  }
`;

const ChipBlock = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: ${(props) => (props.showBox ? `10px` : `10px`)};
`;

const DropDownRow = styled.div`
  width: 100%;
  label {
    padding-bottom: 8px;
    color: ${COLORS.TITLE_BLUE};
    font-weight: 600;
  }
  .MuiAutocomplete-inputRoot {
    border: solid 1px ${COLORS.C4_BORDER};
    margin-top: 0px !important;

    &[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input {
      padding: 7px;
    }
  }
`;

const SearchBlock = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;

  & > div {
    padding-bottom: 0px;
    margin-left: 15px;
    label[for="skillName"] {
      padding-bottom: 8px;
    }
    .MuiInputBase-root {
      margin-top: 26px;
    }
    &:first-child:not(.MuiFormControl-root) {
      width: 40%;
      .MuiInputBase-root {
        margin-top: 0px;
      }
    }
    &:first-child {
      margin-left: 0px;
    }
  }
  button {
    margin-left: 30px;
  }
  .auto-search {
    width: 300px;
    & > div .MuiInputBase-root {
      margin-top: -2px;
    }
    button {
      margin-left: 0px;
    }

    label {
      line-height: 24px;
    }
    & > div {
      padding-bottom: 0px;
    }
    .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]
      .MuiAutocomplete-input {
      padding: 9px 4px;
    }
  }
  .source-dropDown {
    .MuiSelect-selectMenu{
      color: ${COLORS.PRIMARY_BLACK};
      padding-right: 10px;
      text-align: center
    }
    .MuiSelect-icon{
      display: none;
    }
  }
`;

const OptionCutom = styled.div`
  font-size: 12px;
`;

const ContainerX = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px !important;
  gap: 15px;
  >label{
    padding-bottom: 0px !important;
  }
`

const SkillDescriptionX = styled.div`
 position: relative;
 label{
  max-width: fit-content;
 }
 >div{
  margin-top: 10px;
  >div{
    >div{
      margin-top: 10px;
      > textarea[name="skillDescription"] {
        margin-bottom: 20px;
      }
    }
  }
 }
`

const PLSelectionBlock = styled.div`
  border-radius: 8px;
  &:last-child {
    margin-bottom: 0px;
  }
`

const Title = styled.h3`
    color: #333860;
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 10px;
    padding-top: 30px;
`;

const ButtonGroup = styled.div`
  display: flex;
  background-color: #f0f0f0;
  width: max-content;
  padding: 4px;
  border-radius: 6px;
`;

const PLButton = styled.button`
  padding: 6px 12px;
  border-radius: 6px;
  height: 32px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  color: ${({ active }) => (active ? '#ffffff' : COLORS.TEXT)};
  background: ${({ active }) => (active ? COLORS.ACTIVE_GRADIENT : '#f0f0f0')};
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px !important;
  gap: 15px;

  > label {
    padding-bottom: 0px !important;
  }
`;


const Line = styled.div`
  width:calc(100vw - 245px);
  height: 1px;
  background-color:#C4C4C4;  // Or any other color
  margin-top: 32px;
`;
